<template>
    <section class="chart-cont py-5 overflow-hidden" id="about">
        <div class="container py-5 wow fadeIn">
            <div class="row">
                <div class="col-12 text-center mt-4"><h3 class="text-secondary text-title-content wow slideInDown">{{SectionCart.title}}</h3></div>
                <div class="col-12 my-xl-5 my-md-4 d-flex">
                    <div class="vertical-text">NAD+ (ng/mg protein)</div>
                    <div class="container-c">
                        <div class="wrapper-c">
                            <div class="line-dot"></div>
                            <div class="vertical">
                                <span class="numb-h">0</span>
                                <div class="line-1"><span class="numb-v">10</span></div>
                                <div class="line-2"><span class="numb-v">5</span></div>
                            </div>
                            <div class="horizontal">
                                <span class="numb-v">0</span>
                                <div class="line-3"><span class="numb-age">20</span></div>
                                <div class="line-4"><span class="numb-age">40</span></div>
                                <div class="line-5"><span class="numb-age60">60</span></div>
                                <div class="line-6"><span class="numb-age80">80</span></div>
                            </div>
                            <div class="row">
                                <div class="people">
                                    <div class="col graph-1 wow fadeIn align-self-end"></div>
                                    <div class="col graph-2 wow fadeIn align-self-end"></div>
                                    <div class="col graph-3 wow fadeIn align-self-end"></div>
                                    <div class="col graph-4 wow fadeIn align-self-end"></div>
                                    <div class="col graph-5 wow fadeIn align-self-end"></div>
                                    <div class="col graph-6 wow fadeIn align-self-end"></div>
                                    <div class="col graph-7 wow fadeIn align-self-end"></div>
                                    <div class="col graph-8 wow fadeIn align-self-end"></div>
                                </div>
                            </div>
                            <!-- <div class="rocket wow fadeIn">
                                <div class="window"></div>
                                <div class="stripe"></div>
                                <div class="exhaust"></div>
                                <div class="fire-1"></div>
                                <div class="fire-2"></div>
                                <div class="smoke"></div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SectionCart',

  data(){
   return{
     flagImage:"flag-id.png",
     showNavbar: false,
     lastScrollPosition: 0,
     SectionCart:{
         title: null,
         }
   }
 },

  mounted(){
        if(localStorage.getItem('lang_nad') == null){
            localStorage.setItem('lang_nad', 'id')
            this.flagImage = 'flag-id.png'
        } else if(localStorage.getItem('lang_nad') == 'id'){
            this.flagImage = 'flag-id.png'
        } else if(localStorage.getItem('lang_nad') == 'en'){
            this.flagImage = 'flag-en.png'
        }
    
    axios.get(`../../lang.json`).then(response => {
            let dataSectionCart
            if (localStorage.getItem('lang_nad') == 'id'){
                dataSectionCart = response.data.id[0];
            } else if(localStorage.getItem('lang_nad') == 'en'){
                dataSectionCart = response.data.en[0];
            }
            this.SectionCart.title = dataSectionCart.SectionCart.title
            })

    window.addEventListener('scroll', this.onScroll)
  }
}
</script>
